exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dropzone>.dz-preview .dz-details{background-color:var(--primary)!important}", ""]);

// exports
